import styled from "styled-components"

const FooterNewsletter = styled.div`
  ${(props) =>
    props.hasBorderRight === true
      ? "border-right: 1px solid " + props.theme.a_color_gradients.a_dark
      : "border-right: none"};
  & > h2::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  & legend::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  & > div > button {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const Title = styled.h2`

    &::after {
        background-color: ${(props) => props.theme.a_color_gradients.a_dark};
    }
    color: ${(props) => props.theme.d_color_gradients.d_dark};
    }
`
const SectionAlert = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const SectionAlertButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const SectionAlertContent = styled.div`
  & a::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export {
  FooterNewsletter,
  Title,
  SectionAlert,
  SectionAlertButton,
  SectionAlertContent,
}
